export default "__VITE_ASSET__DFMPPF4r__"